import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'
const poizon_component_type = 'poizon-a-row-goods'
const current_page = 82
const block_type = 1499

export function createTrackConfig() {
  console.log('createTrackConfig: ', '====================')
  return {
    poizon_venue_component_content_click(platform, _dataSet) {
      // 新的埋点 banner 组件只有web神策
      if (platform !== 'sensors') return
      const { commonProps = {}, price = '', spuId, logoUrl = '', title, index } = this.props
      return {
        current_page,
        block_type,
        venue_id: commonProps.pageId || '',
        spu_price: price,
        venue_title: document.title,
        component_content_id: spuId,
        component_content_title: title,
        component_content_url: logoUrl,
        component_content_position: index,
        poizon_channel_id,
        poizon_component_type,
        SK: window.dw.getSk(),
      }
    },
    poizon_venue_component_content_exposure(platform, _dataSet) {
      if (platform !== 'sensors') return
      const { commonProps = {}, price = '', spuId, index, logoUrl = '', title } = this.props
      console.log({
        current_page,
        block_type,
        venue_id: commonProps.pageId || '',
        venue_title: document.title,
        component_content_info_list: JSON.stringify([
          {
            component_content_id: spuId,
            component_content_title: title,
            component_content_url: logoUrl,
            component_content_position: index,
            spu_price: price,
          },
        ]),
        poizon_channel_id,
        poizon_component_type,
      })
      return {
        current_page,
        block_type,
        venue_id: commonProps.pageId || '',
        venue_title: document.title,
        component_content_info_list: JSON.stringify([
          {
            component_content_id: spuId,
            component_content_title: title,
            component_content_url: logoUrl,
            component_content_position: index,
            spu_price: price,
          },
        ]),
        poizon_channel_id,
        poizon_component_type,
        SK: window.dw.getSk(),
      }
    },
  }
}
